import Reveal from '@/components/base/Reveal';

export default function AuthorityBridge() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Portrait */}
          <Reveal>
            <div className="relative mx-auto max-w-md lg:max-w-none">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/20 via-transparent to-background-300/40 blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <div className="relative w-full aspect-[4/5]">
                  <img
                    src="/assets/images/josh-profile-image-1.png"
                    alt="Josh Hastings, marketing strategist"
                    title="Josh Hastings — Marketing Strategist"
                    className="absolute inset-0 w-full h-full opacity-70 object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </Reveal>

          {/* Quote */}
          <Reveal delay={100}>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              Results Matter More Than Marketing Noise.
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              Josh&rsquo;s approach is built around identifying what actually
              moves the business forward — then improving the strategy, systems,
              and execution behind those numbers.
            </p>

            <blockquote className="mt-8 rounded-2xl border border-primary-500/30 bg-primary-500/8 p-7">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                <i className="ri-double-quotes-l text-lg"></i>
              </span>
              <p className="mt-4 font-heading font-medium text-xl md:text-2xl text-foreground-950 leading-relaxed">
                &ldquo;The goal isn&rsquo;t to make marketing look busy. The
                goal is to make it produce.&rdquo;
              </p>
              <footer className="mt-5">
                <p className="font-heading font-semibold text-foreground-950">
                  Josh Hastings
                </p>
                <p className="text-sm text-foreground-600">
                  Marketing Strategist
                </p>
              </footer>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
